export const windows = {
  name: "windows" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M4 11.526V6.553l5.684-1.25v6.138L4 11.526ZM20.105 3v8.29l-9.473.142V5.094L20.105 3ZM4 12.474l5.684.085v6.452L4 17.92v-5.447Zm16.105.236V21l-9.473-1.81v-6.622l9.473.143Z"/></svg>`,
  keywords: ["windows"],
  category: "social" as const,
};
